module.exports = __webpack_public_path__ + "media/svgs/TAFA20-Webseite_Pfeil-rechts_dropshadow_black-428f35d023181c431d46289925949cba.svg";